import { useGetGiftcardsWithDetailsQuery } from "src/store/apis/giftcards";
import NoData from "@Components/NoData/NoData";
import { useGiftcardsListing } from "../../context/GiftcardsListingContext";
import { DiscountBrandType } from "src/Modules/Discounts/types";
import GiftCard from "../GiftCard/GiftCard";
import { useTranslation } from "react-i18next";

const DiscountsListLoading = () => {
  return (
    <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
      {Array.from({ length: 10 }).map((_, i) => {
        return <GiftCard loading={true} key={`discounts-${i}`} code={"###"}/>;
      })}
    </div>
  );
};

export default function DiscountsList() {
  const { filters } = useGiftcardsListing();
  const { i18n } = useTranslation();
  const { isFetching, data, error } = useGetGiftcardsWithDetailsQuery({
    ...filters,
    Page: 1,
    PageSize: 100000,
    lang: i18n.language,
  });
  if (isFetching) return <DiscountsListLoading />;
  if (error || !data?.length)
    return (
      <div className="flex min-h-[50vh] w-full items-center justify-center">
        <NoData />
      </div>
    );

  return (
    <div className="grid w-full grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-5">
      {data.map((brand: DiscountBrandType) => (
        <GiftCard key={brand.code} {...brand}/>
      ))}
    </div>
  );
}
